import { createContext, PureComponent } from 'preact-compat'
import { createRef } from 'preact'

export interface PageUnloadContextValue {
  lock: (content: string, data?: string | null) => void
  unlock: () => void
}

export const PageUnloadContext = createContext<PageUnloadContextValue>({
  lock: () => {
    throw new Error('Something went wrong. The page unload context was used without a provider')
  },
  unlock: () => {
    throw new Error('Something went wrong. The page unload context was used without a provider')
  }
})

class PageUnloadContextProvider extends PureComponent {
  hasUnsavedChanges = createRef()

  componentDidMount () {
    window.addEventListener('beforeunload', this.onUnload)
  }

  componentWillUnmount () {
    window.removeEventListener('beforeunload', this.onUnload)
  }

  onUnload = (e: BeforeUnloadEvent) => {
    if (this.hasUnsavedChanges.current) {
      e.preventDefault()
      e.returnValue = ''
    }
  }

  value = {
    lock: (content: string, data: string | null = '') => {
      this.hasUnsavedChanges.current = (content !== '' && content !== data)
    },
    unlock: () => {
      this.hasUnsavedChanges.current = false
    }
  }

  render () {
    const { children } = this.props

    return (
      <PageUnloadContext.Provider value={this.value}>
        {children}
      </PageUnloadContext.Provider>
    )
  }
}

export default PageUnloadContextProvider
